































































































/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { EventBus } from "../event-bus";
import ConfirmationModal from "./ConfirmationModal.vue";

@Component({
  components: {
    ConfirmationModal,
  },
})
export default class CreateAccount extends Vue {
  private user = {
    firstName: "",
    lastName: "",
    extension: "",
    description: "",
  };

  private confirmationModalFlag = false;
  private errorModalFlag = false;

  private firstNameRules: any = [];
  private lastNameRules: any = [];
  private extensionRules: any = [];
  private descriptionRules: any = [];

  private errorText = "";
  private errorTitle = "";

  @Prop() readonly value!: boolean;

  created() {
    EventBus.$off('closeErrorModal')
    EventBus.$off('closeConfirmationModal')
    EventBus.$off('closeCreateAccountModal')

    EventBus.$on("closeConfirmationModal", (value: boolean) => {
      this.confirmationModalFlag = value;
    });

    EventBus.$on("closeErrorModal", (value: boolean) => {
      this.errorModalFlag = value;
    });

    EventBus.$on("closeCreateAccountModal", () => {
      this.user = {
        firstName: "",
        lastName: "",
        extension: "",
        description: "",
      };
    });
  }

  get show() {
    return this.value;
  }
  set show(value: boolean) {
    EventBus.$emit("closeCreateAccountModal", value);
  }

  @Watch("user.firstName")
  firstNameChanged() {
    this.firstNameRules = [];
  }

  @Watch("user.lastName")
  lastNameChanged() {
    this.lastNameRules = [];
  }

  @Watch("user.extension")
  extensionChanged() {
    this.extensionRules = [];
  }

  @Watch("user.description")
  descriptionChanged() {
    this.descriptionRules = [];
  }

  private submitHandler(): void {
    this.firstNameRules = [
      (v: any) => !!v || "First Name is required",
      (v: any) =>
        /^[a-zA-Z]+$/.test(v) || "First Name must contain only letters",
    ];

    this.lastNameRules = [
      (v: any) => !!v || "Last Name is required",
      (v: any) =>
        /^[a-zA-Z]+$/.test(v) || "Last Name must contain only letters",
    ];

    this.extensionRules = [
      (v: any) => !!v || "Extension is required",
      (v: any) =>
        /^\d{3,5}$/.test(v) || "Extension must be between 3 and 5 digits",
    ];

    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    setTimeout(function () {
      // In order for TypeScript to know which type is being used for form, we need to cast the value.
      const result = (
        self.$refs.form as Vue & {
          validate: () => boolean;
        }
      ).validate();
      console.log("result of validation:", result);
      console.log("user data to be submitted:", self.user);
      if (result) {
        // successful validation -> open confirmation modal
        self.confirmationModalFlag = true;
      }
    });
  }
  // close modal and clear input fields
  private cancel(): void {
    this.show = false;
    this.user = {
      firstName: "",
      lastName: "",
      extension: "",
      description: "",
    };
  }
}
